import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tableReducer from './slices/tableSlice';
import tableDataReducer from './slices/tableDataSlice';
import transferReducer from './slices/transferSlice';
import userReducer from './slices/userSlice';
import errorReducer from './slices/errorSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tables: tableReducer,
    tableData: tableDataReducer,
    transfers: transferReducer,
    users: userReducer,
    error: errorReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;